export default __webpack_public_path__ + "static/media/ZOO.1c24ee48.png";